module.exports = __webpack_public_path__ + "static/media/hydraulic-hose-mr-card-front.5bccaa26.jpeg";